/* BuyYourGadgets Theme JS */
(function() {
  'use strict';

  /* --- Cart Drawer --- */
  var cartToggle   = document.getElementById('cart-toggle');
  var cartClose    = document.getElementById('cart-close');
  var cartDrawer   = document.getElementById('cart-drawer');
  var cartOverlay  = document.getElementById('cart-overlay');

  function openCart() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    cartDrawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose)  cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* --- Add to Cart (product cards) --- */
  document.querySelectorAll('.product-card__atc').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = btn.dataset.productId;
      if (!variantId) return;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = 'Added!';
        btn.style.background = '#185FA5';
        btn.style.color = '#fff';
        refreshCart();
        setTimeout(function() {
          btn.textContent = 'Add to Cart';
          btn.style.background = '';
          btn.style.color = '';
          btn.disabled = false;
        }, 1800);
      })
      .catch(function() {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      });
    });
  });

  /* --- Add to Cart (product page) --- */
  var atcBtn = document.querySelector('.add-to-cart-btn');
  if (atcBtn) {
    atcBtn.addEventListener('click', function() {
      var form = document.querySelector('form[action="/cart/add"]');
      if (!form) return;
      var variantSelect = form.querySelector('.product-variant-select') || form.querySelector('[name="id"]');
      var quantity = form.querySelector('[name="quantity"]');
      if (!variantSelect) return;
      atcBtn.textContent = 'Adding to Cart...';
      atcBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantSelect.value, quantity: quantity ? quantity.value : 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        atcBtn.textContent = '✓ Added to Cart';
        refreshCart();
        openCart();
        setTimeout(function() {
          atcBtn.textContent = 'Add to Cart';
          atcBtn.disabled = false;
        }, 2000);
      })
      .catch(function(err) {
        console.error(err);
        atcBtn.textContent = 'Add to Cart';
        atcBtn.disabled = false;
      });
    });
  }

  /* --- Refresh Cart Drawer Count --- */
  function refreshCart() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var badge = document.querySelector('.cart-count');
      if (cart.item_count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          var btn = document.getElementById('cart-toggle');
          if (btn) btn.appendChild(badge);
        }
        badge.textContent = cart.item_count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  /* --- Mobile Nav Toggle --- */
  var mobileToggle = document.getElementById('mobile-nav-toggle');
  var headerNav    = document.getElementById('header-nav');
  if (mobileToggle && headerNav) {
    mobileToggle.addEventListener('click', function() {
      var isOpen = headerNav.classList.toggle('open');
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* --- Option selectors → update variant --- */
  var optionSelects = document.querySelectorAll('.product-option__select');
  if (optionSelects.length) {
    optionSelects.forEach(function(sel) {
      sel.addEventListener('change', syncVariant);
    });
  }
  function syncVariant() {
    var variantSel = document.querySelector('.product-variant-select');
    if (!variantSel) return;
    var options = Array.from(document.querySelectorAll('.product-option__select')).map(function(s){ return s.value; });
    Array.from(variantSel.options).forEach(function(opt) {
      var title = opt.textContent.replace(' — Sold out','').trim();
      if (title === options.join(' / ')) { variantSel.value = opt.value; }
    });
  }

  /* --- Sticky header shadow on scroll --- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.style.boxShadow = window.scrollY > 4 ? '0 2px 20px rgba(0,0,0,0.10)' : '';
    }, { passive: true });
  }

})();
